const createCardsetMulti = (input, shuffler) => {
  const cards = {};

  Object.keys(input)
    .forEach(key => {
      if (Array.isArray(input[key])) {
        const multiValue = [...input[key]];
        cards[key] = shuffler(multiValue).pop();
      } else {
        cards[key] = input[key];
      }
    });

  return {
    model: 'simple',
    cards
  };
};

export default createCardsetMulti;
